// One relay socket shared by project badges, task controls and attached terminals.
import { api, getToken } from '../api.js';
import { getUser } from '../auth.js';
import { createDeviceRelayClient } from './device-relay-client.js';

export const deviceSessionClient = createDeviceRelayClient({
  getToken,
  getUserId: () => getUser()?.id ?? null,
  renewAuth: () => api.get('/auth/me'),
});
